import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import App from './App';
import CountryDetails from './components/CountryDetails';
import './styles/tailwind.generated.css';

ReactDOM.render(
  <Router>
    <Switch>
      <Route exact path="/" component={App} />
      <Route path="/countries/:name" component={CountryDetails} />
    </Switch>
  </Router>,
  document.getElementById('root')
);